import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import FormHelperText from '@mui/material/FormHelperText'

const ITEM_HEIGHT = 46
const ITEM_PADDING_TOP = 8
const FIELD_WIDTH = 250

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: FIELD_WIDTH,
    },
  },
}

const getStyles = (item, selectedItems, theme) => {
  const selected_items = typeof selectedItems === 'string' ? 
  selectedItems.split(',') : 
  selectedItems
  return {
    fontWeight:
    selected_items && selected_items.indexOf(item) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  }
}

const CustomSelectField = (props) => {
  const { currentValue, setCurrentValue } = props
  const { items } = props
  const { item_titles, self_item_titles } = props
  const { label, size, empty } = props
  const { multiple } = props
  const { field_key } = props
  const { sx } = props
  const { disabled, error, errorText, required } = props
  const { index } = props
  const { outlinedInputSx } = props
  const { loginHelperText, loginHelperSx } = props
  const { variant } = props
  
  const theme = useTheme()

  const [open, setOpen] = useState(false)

  const labelStyle = sx ? {
    color: sx.color ? sx.color : undefined,
    background: sx.background ? sx.background : 'none',
    padding: sx.background ? '1px 5px' : '0px',
  } : {}

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    if (!disabled) {
      setOpen(true)
    } else {
      setOpen(false)
    }    
  }

  const onChange = (event) => {
    const { target: { value } } = event
    
    if (multiple) {
      setCurrentValue(
        typeof value === 'string' ? 
        value.split(',') : 
        value,
        field_key,
        index
      )
    } else {
      setCurrentValue(value, field_key, index)
    }
  }

  useEffect(() => {
    if (multiple) {
      if (currentValue && currentValue.length === 0 && !empty) {
        const default_items = items.filter(item => item.default)
        setCurrentValue(default_items.map(item => item.value))
      }
    } else {
      if (currentValue && currentValue.length === 0 && !empty) {
        const default_item = items.filter(item => item.default)
        setCurrentValue(default_item[0].value)
      }
    }
  }, [currentValue,items,multiple,setCurrentValue,empty])
  
  return (
    <>
      <FormControl 
        error={error}
        required={required}
        variant={variant ? variant : 'outlined'}
        sx={{ 
          width: FIELD_WIDTH,
          ...sx,
          opacity: disabled ? 0.7 : 1,
        }}
        size={size ? size : "medium"}
      >
        <InputLabel>
          { label && <Box component='span' sx={labelStyle}>{label}</Box> }
        </InputLabel>
        <Select
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          multiple={multiple ? multiple : false}
          value={currentValue}
          onChange={onChange}
          input={
            !variant ?
            <OutlinedInput
              label={label}
              sx={outlinedInputSx}
            /> : null
          }
          MenuProps={MenuProps}
        >
          {
            items.map((item) => (
              <MenuItem
                key={item.value}
                value={item.value}
                style={getStyles(item.value, currentValue, theme)}
              >
                {self_item_titles ? item.keyword : item_titles[item.keyword] }
              </MenuItem>
            ))
          }
        </Select>
        {
          error && 
          <FormHelperText>
            {errorText}
          </FormHelperText>
        }
      </FormControl>
      {
        loginHelperText &&
        <FormHelperText sx={loginHelperSx}>
          {loginHelperText}
        </FormHelperText>
      }
    </>
  )
}

export default CustomSelectField